import { useEffect, useState } from "react";
import { customerAccountApi } from "../api/service.api";
import { DetailCustomerAccountType, PagingType } from "../types";

export const useGetDetail = (
  code: string,
  initialParams?: Record<string, any>
) => {
  const [params, setParams] = useState<Record<string, any>>(
    initialParams || {}
  );
  const [data, setData] = useState<DetailCustomerAccountType | null>(null);
  const [paging, setPaging] = useState<PagingType | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  const fetchData = async (code: string, fetchParams: Record<string, any>) => {
    try {
      setLoading(true);

      const profileResponse: any = await customerAccountApi.detail(code);
      const favoriteResponse: any = await customerAccountApi.favorite(
        code,
        fetchParams
      );

      setData({
        ...profileResponse?.data?.data,
        events: {
          data: favoriteResponse?.data?.data?.events,
          paging: favoriteResponse?.data?.data?.paging,
        },
      });

      return true;
    } catch (err: any) {
      console.log("Get detail customer account failed:", err);

      setError(err.message || "Something wrong");

      return false;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(code, params);
  }, [JSON.stringify(params)]);

  return {
    data,
    fetchData,
    paging,
    loading,
    error,
    params,
    setParams,
  };
};
